import { Context } from '@nuxt/types'
import {
  GetServerCookie,
  LinkedBroadcasterCookie,
} from '~/assets/ts/utils/cookies'
import { WebcastDashboardOptions } from '~/apiclient/apiwebcasts'
import { PromiseAll } from '~/assets/ts/utils/misc'

export default async function (context: Context) {
  const { store } = context
  const broadcasterID = GetServerCookie(LinkedBroadcasterCookie, context)
  await store.dispatch('dashboard/fetchBroadcasterApiKey', {
    broadcasterID,
  })
  const calls = [
    await store.dispatch('webcasts/fetchWebcastsInProgress', {
      broadcasterID,
      ...WebcastDashboardOptions,
    }),
  ]

  if (!store.getters['dashboard/broadcasterPrivateData']) {
    calls.push(
      await store.dispatch('dashboard/fetchBroadcasterPrivateData', {
        broadcasterID,
      })
    )
  }
  await PromiseAll(calls)
}
